// extracted by mini-css-extract-plugin
export default {"radio":"ChangeRequisites_radio__Ckbhu"};